import { dataSourceWholeItems } from '@/resources/data-source';
import generateID from '../generate-id';

export function getRefName(ref: string): string {
  return ref ? ref.split('@')[1] ?? '' : '';
}

/**
 * 根据引用图片名称，查找图片路径
 * @param resAst
 * @param name
 * @returns
 */
export function findResImagePath(resAst: Ast, name: string): string {
  const { children } = resAst;
  const res = children.find(
    (item) => item.tag === 'image' && item.attrsMap.name === name
  );
  return res?.attrsMap.src || '';
}

/**
 * 根据 name 查找资源,资源可能有多个，colorgroup不同
 * @param resAst
 * @param name
 * @returns
 */
export function findResAst(resAst: Ast, name: string): Ast[] {
  const { children } = resAst;
  return children.filter((item) => item.attrsMap.name === name);
}

/**
 * 生成theme配色数据
 * @param colorGroupTable
 * @returns
 */
export function getColorGroupTable(
  colorGroupTable: string
): StoreThemeColorItem[] {
  return colorGroupTable.split(',').map((item, index) => {
    return {
      id: generateID(),
      name: '配色' + index + 1,
      color: item
    };
  });
}

/**
 * 根据 name 返回图片资源对象
 * @param resAst
 * @param name
 * @param colors
 * @returns
 */
export function getImageObject(
  resAst: Ast,
  name: string,
  colors: StoreThemeColorItem[]
): Record<string, string[]> {
  const resAstList = findResAst(resAst, name);
  if (resAstList.length > 0) {
    const images: Record<string, string[]> = {};
    const isArray = resAstList[0].tag === 'ImageArray';
    resAstList.forEach((item) => {
      const colorIdx = item.attrsMap.colorGroup
        ? colors?.findIndex((color) => color.color === item.attrsMap.colorGroup)
        : 0;
      // 解决colorIdx=-1报错，不过这样是否有问题？
      if (colorIdx < 0) return;
      if (!isArray) {
        images[colors[colorIdx].id] = [item.attrsMap.src];
      } else {
        const imgArr: string[] = [];
        item.children.forEach(({ attrsMap }) => {
          imgArr.push(attrsMap.src);
        });
        images[colors[colorIdx].id] = imgArr;
      }
    });
    return images;
  }
  return {};
}

/**
 * 返回图层是否启用recolor着色
 * @param resAst
 * @param imgName
 * @returns
 */
export function getLayerRecolorEnabled(resAst: Ast, imgName: string): boolean {
  const resAstList = findResAst(resAst, imgName);
  if (resAstList.length > 0) {
    return resAstList[0].attrsMap.recolorEnable === 'true';
  }
  return false;
}

/**
 * 返回表盘类型
 * @param ast
 * @returns
 */
export function getWatchFaceType(
  ast: Ast
): 'normal' | 'portrait' | 'photoAlbum' {
  const { children } = ast;
  // 表盘类型
  let watchFaceType: 'normal' | 'portrait' | 'photoAlbum' = 'normal';

  const themes = children.filter((item) => item.tag === 'Theme');
  themes.forEach((item) => {
    const { attrsMap } = item;
    if (attrsMap.isPhotoAlbumWatchface === 'true') {
      watchFaceType = attrsMap.fg !== undefined ? 'portrait' : 'photoAlbum';
      return;
    }
  });
  return watchFaceType;
}

export const getParentSourceKey = (sourceKey: string) => {
  const parentItem = dataSourceWholeItems.find((item) =>
    item.children?.includes(sourceKey)
  );
  return parentItem?.key ?? sourceKey ?? '';
};
